/**
 * @author      autogenerated
 * @copyright   Copyright (c) 2025, Zumper
 * @description CityType
 */

export enum CityType {
  CITY = 1,
  METRO = 2,
  MILITARY = 3,
  UNIVERSITY = 4,
  HONEYPOT = 5,
  TRANSIT = 6,
}

Object.defineProperty(CityType, '__ENUM_NAME', {
  value: 'CityType',
  writable: false,
  configurable: false,
  enumerable: false,
})
